import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'
import lang from '@/lang'

const TransactionSendEmail = React.lazy(() => import('@/modules/transaction/components/email/transaction-send-email'))
const LetterList = React.lazy(() => import('@/modules/transactionLetter/list/letter-list'))
const LetterEditView = React.lazy(() => import('@/modules/transactionLetter/letter-edit-view'))
const LetterDetail = React.lazy(() => import('@/modules/transactionLetter/detail/letter-detail'))

const transactionLetterRoutes = (
  <>
    <Route path='letter/*' element={<RedirectToPlural />} />
    <Route path='letters' Component={LetterList} handle={{ title: lang.letterTransaction.letters, options: { noBackgroundColor: true } }} />

    <Route path='letters/new' Component={LetterEditView} />
    <Route path='letters/edit/:id' Component={LetterEditView} />
    <Route path='letters/:id' Component={LetterDetail} />
    <Route path='letters/send/:id' Component={TransactionSendEmail} handle={{ options: { noBackgroundColor: true } }} />
    <Route path='letters/new/customer/:customerId' Component={LetterEditView} />
  </>
)

export default transactionLetterRoutes
